import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { MediaHits, type MediaHitsQuery, type MediaHitsQueryVariables } from './index.graphql';

type MediaHit = NonNullable<MediaHitsQuery['petition']>['mediaHitsConnection']['nodes'][0];

type Result = {
	isLastPage: boolean;
	numberOfStarterMedia: number;
	mediaHits: readonly MediaHit[];
};

const EMPTY_MEDIA_HITS: Result = {
	isLastPage: true,
	numberOfStarterMedia: 0,
	mediaHits: [],
};

export async function fetchMediaHits(petitionId: string, { gql: { fetch } }: UtilityContext) {
	try {
		const { data } = await fetch<NonNullable<MediaHitsQuery>, MediaHitsQueryVariables>({
			query: MediaHits,
			variables: {
				petitionId,
			},
			batched: false,
			rejectOnError: true,
		});

		if (!data.petition?.mediaHitsConnection) {
			return EMPTY_MEDIA_HITS;
		}

		return {
			isLastPage: !data.petition.mediaHitsConnection.pageInfo.hasNextPage,
			numberOfStarterMedia: data.petition.mediaHitsConnection.totalCount,
			mediaHits: data.petition.mediaHitsConnection.nodes,
		};
	} catch (error) {
		return EMPTY_MEDIA_HITS;
	}
}
